import TransplanteService from "@/views/RecursosPropriosQuestionarios/shared/services/TransplanteService";
import QuestionarioService from "../../services/QuestionarioService";

import ValidacaoTransplanteMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/validation/ValidacaoTransplanteMixin";

export default {
  mixins: [TransplanteService, ValidacaoTransplanteMixin, QuestionarioService],
  data() {
    return {
      transplantes: [],
      listaTransplantes: [],
      clickSwitch: {
        transplante: false
      },
      outrosTransplantes: false,
      campoOutrosTranplantes: ""
    };
  },
  computed: {
    // pega o tipo de questionario do vuex store
    tipoQuest() {
      return this.$store.getters.getTipoQuestionario.tipoQuestionario;
    }
  },
  beforeMount() {
    this.preencheDadosTransplante();
  },
  methods: {
    // Métodos que inicializam os combos
    inicializarTransplante() {
      return this.getTransplante(
        this.$store.getters.getTipoQuestionario.tipoQuestionario
      ).then(({ data }) => {
        if (data) {
          this.listaTransplantes = data;
        }
      });
    },
    // Método que verifica se tem algum texto nulo, é usado para testar
    verificaNulo(texto) {
      return !!texto;
    },
    // Método que prepara os dados que serao enviados para a api salvar/alterar
    preparaDados(isUpdate) {
      const transplantes = [...this.transplantes];
      let objetoQuestionarioTransplante = [];
      transplantes.forEach(transplante => {
        if (transplante.tipoTransplante.includes("Outro")) {
          objetoQuestionarioTransplante.push({
            idQuestionarioTransplante: "",
            tipoTransplante:
              typeof transplante.tipoTransplante == "string"
                ? transplante
                : transplante.tipoTransplante,
            tipoPublicoAlvo: null,
            outro: this.verificaNulo(this.campoOutrosTranplantes)
              ? this.campoOutrosTranplantes
              : ""
          });
        } else {
          objetoQuestionarioTransplante.push({
            idQuestionarioTransplante:
              isUpdate &&
              this.verificaNulo(transplante.idQuestionarioTransplante)
                ? transplante.idQuestionarioTransplante
                : "",
            tipoTransplante:
              typeof transplante.tipoTransplante == "string"
                ? transplante
                : transplante.tipoTransplante,
            tipoPublicoAlvo: null,
            outro: ""
          });
        }
      });
      return objetoQuestionarioTransplante;
    },
    // Métodos que preenchem os campos e/ou ativa os switches dos mesmos
    preencheDadosTransplante() {
      const data = this.$store.getters.getPayloadServidor();

      if (!data) return;

      if (data.status === 204) return;

      this.transplantes = [];

      if (data.transplantes) {
        this.transplantes = data.transplantes.map(transplante => {
          if (transplante.tipoTransplante.tipoTransplante.includes("Outro")) {
            this.campoOutrosTranplantes = transplante.outro
              ? transplante.outro
              : "";
          }
          return {
            id: transplante.tipoTransplante.id,
            tipoTransplante: transplante.tipoTransplante.tipoTransplante,
            idQuestionarioTransplante: transplante.idQuestionarioTransplante,
            outro: transplante.outro
          };
        });
        this.clickSwitch.transplante = data.transplantes.length > 0;
      }
    },
    checkOutros(transplantes) {
      if (!transplantes || transplantes.length === 0) return;
      let arr = [];
      transplantes.map(el => {
        arr.push(el.tipoTransplante);
      });
      arr.find(transplante => {
        if (transplante.includes("Outro")) {
          this.outrosTransplantes = true;
          return true;
        } else {
          this.outrosTransplantes = false;
          return false;
        }
      });
      this.chequeOutrosTranplantes();
    }
  },
  watch: {
    transplantes: "checkOutros",
    // inicializa servicos quando servidor responde com o tipo de questionario
    tipoQuest(quest) {
      if (quest) {
        this.inicializarTransplante();
      }
    }
  }
};
